import { createSlice } from "@reduxjs/toolkit";
import { createReceipt, getReceipt, updateReceipt, deleteReceipt } from "../actions/receiptActionsHelper";
import { receiptsObject } from "../stateObject/receiptsObject";

const initialState = receiptsObject;

const receiptSlice = createSlice({
    name: "receipt",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        resetState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReceipt.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getReceipt.success, (state, action) => {
                state.receiptData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getReceipt.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to fetch receipts.";
            })
            .addCase(createReceipt.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createReceipt.success, (state, action) => {
                state.receiptData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(createReceipt.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Receipt creation failed. Please try again.";
            })
            .addCase(updateReceipt.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateReceipt.success, (state, action) => {
                state.receiptData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(updateReceipt.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Receipt update failed. Please try again.";
            })
            .addCase(deleteReceipt.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteReceipt.success, (state, action) => {
                state.receiptData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(deleteReceipt.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Receipt deletion failed. Please try again.";
            });
    },
});

export const { setLoading, clearError, resetState: resetReceiptState } = receiptSlice.actions;
export default receiptSlice.reducer;
